const modalNameKey = "addMachineGroupsAdminPanelModal";

export const addMachineGroupsAdminPanelModalEn = {
  [modalNameKey]: {
    title: "Add Machine Group",
    editTitle: "Edit Machine Group",
    groupNameLabel: "Group Name",
    groupNamePlaceholder: "Type here",
    organizationLabel: "Organization",
    fixValidateFieldText: "Please complete the following fields:",
    selectOrganization: "Choose here",
    loadingOrganizations: "Loading organizations...",
    machineLibraryLabel: "Machine library",
    chooseOrganizationToSeeMachineLibrary:
      "Choose Organization to see the Machine Library",
    noMachinesFound: "No machines found",
    machineName: "Machine Name",
    manufacturer: "Manufacturer",
    ipAddress: "IP Address",
    saveButton: "Save",
    cancelButton: "Cancel",
    machineGroupCreatedSuccessfully: "Machine group created successfully",
    machineGroupUpdatedSuccessfully: "Machine group updated successfully",
    errorFetchingOrganizations: "Failed to fetch organizations",
    errorFetchingMachines: "Failed to fetch machines",
    errorCreatingMachineGroup: "Failed to create machine group",
    errorUpdatingMachineGroup: "Failed to update machine group",
  },
};

export const addMachineGroupsAdminPanelModalPtBr = {
  [modalNameKey]: {
    title: "Adicionar grupo de máquinas",
    editTitle: "Editar grupo de máquinas",
    groupNameLabel: "Nome do grupo",
    groupNamePlaceholder: "Digite aqui",
    organizationLabel: "Organização",
    fixValidateFieldText: "Por favor, preencha os seguintes campos:",
    selectOrganization: "Escolha aqui",
    loadingOrganizations: "Carregando organizações...",
    machineLibraryLabel: "Biblioteca de máquinas",
    chooseOrganizationToSeeMachineLibrary:
      "Selecione uma organização para ver a biblioteca de máquinas",
    noMachinesFound: "Nenhuma máquina encontrada",
    machineName: "Nome da máquina",
    manufacturer: "Fabricante",
    ipAddress: "Endereço IP",
    saveButton: "Salvar",
    cancelButton: "Cancelar",
    machineGroupCreatedSuccessfully: "Grupo de máquinas criado com sucesso",
    machineGroupUpdatedSuccessfully: "Grupo de máquinas atualizado com sucesso",
    errorFetchingOrganizations: "Falha ao buscar organizações",
    errorFetchingMachines: "Falha ao buscar máquinas",
    errorCreatingMachineGroup: "Falha ao criar grupo de máquinas",
    errorUpdatingMachineGroup: "Falha ao atualizar grupo de máquinas",
  },
};

export const addMachineGroupsAdminPanelModalDe = {
  [modalNameKey]: {
    title: "Maschinengruppe hinzufügen",
    editTitle: "Maschinengruppe bearbeiten",
    groupNameLabel: "Gruppenname",
    groupNamePlaceholder: "Hier eingeben",
    organizationLabel: "Organisation",
    fixValidateFieldText: "Bitte füllen Sie die folgenden Felder aus:",
    selectOrganization: "Hier auswählen",
    loadingOrganizations: "Organisationen werden geladen...",
    machineLibraryLabel: "Maschinenbibliothek",
    chooseOrganizationToSeeMachineLibrary:
      "Wählen Sie eine Organisation aus, um die Maschinenbibliothek anzuzeigen",
    noMachinesFound: "Keine Maschinen gefunden",
    machineName: "Maschinenname",
    manufacturer: "Hersteller",
    ipAddress: "IP-Adresse",
    saveButton: "Speichern",
    cancelButton: "Abbrechen",
    machineGroupCreatedSuccessfully: "Maschinengruppe erfolgreich erstellt",
    machineGroupUpdatedSuccessfully: "Maschinengruppe erfolgreich aktualisiert",
    errorFetchingOrganizations: "Organisationen konnten nicht abgerufen werden",
    errorFetchingMachines: "Maschinen konnten nicht abgerufen werden",
    errorCreatingMachineGroup: "Maschinengruppe konnte nicht erstellt werden",
    errorUpdatingMachineGroup:
      "Maschinengruppe konnte nicht aktualisiert werden",
  },
};

export const addMachineGroupsAdminPanelModalZhHans = {
  [modalNameKey]: {
    title: "添加机器组",
    editTitle: "编辑机器组",
    groupNameLabel: "组名称",
    groupNamePlaceholder: "在此输入",
    organizationLabel: "组织",
    fixValidateFieldText: "请填写以下字段：",
    selectOrganization: "在此选择",
    loadingOrganizations: "正在加载组织...",
    machineLibraryLabel: "机器库",
    chooseOrganizationToSeeMachineLibrary: "选择组织以查看机器库",
    noMachinesFound: "未找到机器",
    machineName: "机器名称",
    manufacturer: "制造商",
    ipAddress: "IP 地址",
    saveButton: "保存",
    cancelButton: "取消",
    machineGroupCreatedSuccessfully: "机器组已成功创建",
    machineGroupUpdatedSuccessfully: "机器组已成功更新",
    errorFetchingOrganizations: "获取组织失败",
    errorFetchingMachines: "获取机器失败",
    errorCreatingMachineGroup: "创建机器组失败",
    errorUpdatingMachineGroup: "更新机器组失败",
  },
};

export const addMachineGroupsAdminPanelModalEs = {
  [modalNameKey]: {
    title: "Añadir grupo de máquinas",
    editTitle: "Editar grupo de máquinas",
    groupNameLabel: "Nombre del grupo",
    groupNamePlaceholder: "Escribe aquí",
    organizationLabel: "Organización",
    fixValidateFieldText: "Por favor, completa los siguientes campos:",
    selectOrganization: "Elige aquí",
    loadingOrganizations: "Cargando organizaciones...",
    machineLibraryLabel: "Biblioteca de máquinas",
    chooseOrganizationToSeeMachineLibrary:
      "Selecciona una organización para ver la biblioteca de máquinas",
    noMachinesFound: "No se encontraron máquinas",
    machineName: "Nombre de la máquina",
    manufacturer: "Fabricante",
    ipAddress: "Dirección IP",
    saveButton: "Guardar",
    cancelButton: "Cancelar",
    machineGroupCreatedSuccessfully: "Grupo de máquinas creado correctamente",
    machineGroupUpdatedSuccessfully:
      "Grupo de máquinas actualizado correctamente",
    errorFetchingOrganizations: "No se pudieron obtener las organizaciones",
    errorFetchingMachines: "No se pudieron obtener las máquinas",
    errorCreatingMachineGroup: "No se pudo crear el grupo de máquinas",
    errorUpdatingMachineGroup: "No se pudo actualizar el grupo de máquinas",
  },
};

export const addMachineGroupsAdminPanelModalIt = {
  [modalNameKey]: {
    title: "Aggiungi gruppo macchine",
    editTitle: "Modifica gruppo macchine",
    groupNameLabel: "Nome del gruppo",
    groupNamePlaceholder: "Scrivi qui",
    organizationLabel: "Organizzazione",
    fixValidateFieldText: "Compila i seguenti campi:",
    selectOrganization: "Scegli qui",
    loadingOrganizations: "Caricamento organizzazioni...",
    machineLibraryLabel: "Libreria macchine",
    chooseOrganizationToSeeMachineLibrary:
      "Seleziona un'organizzazione per visualizzare la libreria macchine",
    noMachinesFound: "Nessuna macchina trovata",
    machineName: "Nome macchina",
    manufacturer: "Produttore",
    ipAddress: "Indirizzo IP",
    saveButton: "Salva",
    cancelButton: "Annulla",
    machineGroupCreatedSuccessfully: "Gruppo di macchine creato correttamente",
    machineGroupUpdatedSuccessfully:
      "Gruppo di macchine aggiornato correttamente",
    errorFetchingOrganizations: "Impossibile recuperare le organizzazioni",
    errorFetchingMachines: "Impossibile recuperare le macchine",
    errorCreatingMachineGroup: "Impossibile creare il gruppo di macchine",
    errorUpdatingMachineGroup: "Impossibile aggiornare il gruppo di macchine",
  },
};

export const addMachineGroupsAdminPanelModalNl = {
  [modalNameKey]: {
    title: "Machinegroep toevoegen",
    editTitle: "Machinegroep bewerken",
    groupNameLabel: "Groepsnaam",
    groupNamePlaceholder: "Typ hier",
    organizationLabel: "Organisatie",
    fixValidateFieldText: "Vul de volgende velden in:",
    selectOrganization: "Kies hier",
    loadingOrganizations: "Organisaties laden...",
    machineLibraryLabel: "Machinebibliotheek",
    chooseOrganizationToSeeMachineLibrary:
      "Selecteer een organisatie om de machinebibliotheek te bekijken",
    noMachinesFound: "Geen machines gevonden",
    machineName: "Machinenaam",
    manufacturer: "Fabrikant",
    ipAddress: "IP-adres",
    saveButton: "Opslaan",
    cancelButton: "Annuleren",
    machineGroupCreatedSuccessfully: "Machinegroep succesvol aangemaakt",
    machineGroupUpdatedSuccessfully: "Machinegroep succesvol bijgewerkt",
    errorFetchingOrganizations: "Organisaties ophalen is mislukt",
    errorFetchingMachines: "Machines ophalen is mislukt",
    errorCreatingMachineGroup: "Machinegroep aanmaken is mislukt",
    errorUpdatingMachineGroup: "Machinegroep bijwerken is mislukt",
  },
};

export const addMachineGroupsAdminPanelModalTr = {
  [modalNameKey]: {
    title: "Makine Grubu Ekle",
    editTitle: "Makine Grubunu Düzenle",
    groupNameLabel: "Grup Adı",
    groupNamePlaceholder: "Buraya yazın",
    organizationLabel: "Organizasyon",
    fixValidateFieldText: "Lütfen aşağıdaki alanları doldurun:",
    selectOrganization: "Buradan seçin",
    loadingOrganizations: "Organizasyonlar yükleniyor...",
    machineLibraryLabel: "Makine kütüphanesi",
    chooseOrganizationToSeeMachineLibrary:
      "Makine kütüphanesini görmek için bir organizasyon seçin",
    noMachinesFound: "Makine bulunamadı",
    machineName: "Makine Adı",
    manufacturer: "Üretici",
    ipAddress: "IP Adresi",
    saveButton: "Kaydet",
    cancelButton: "İptal",
    machineGroupCreatedSuccessfully: "Makine grubu başarıyla oluşturuldu",
    machineGroupUpdatedSuccessfully: "Makine grubu başarıyla güncellendi",
    errorFetchingOrganizations: "Organizasyonlar alınamadı",
    errorFetchingMachines: "Makineler alınamadı",
    errorCreatingMachineGroup: "Makine grubu oluşturulamadı",
    errorUpdatingMachineGroup: "Makine grubu güncellenemedi",
  },
};
